<template>
  <content-loader :height="226" :width="750">
    <rect x="0" y="60" rx="0" ry="0" width="130" height="100" />
    <rect x="160" y="60" rx="0" ry="0" width="580" height="120" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
